import {distinctUntilChanged, OperatorFunction} from 'rxjs';
import {compareSignatures} from '../signature/compareSignatures';

export function distinctLikeABoss<T>(): OperatorFunction<T, T> {
    return distinctUntilChanged(compareSignatures);
}